import { UAParser } from 'ua-parser-js';

export const getIsMacOs = () => {
  if (window.electron?.isMac) {
    return true;
  }

  const parser = new UAParser();
  const result = parser.getResult();
  return result.os.name?.toLowerCase().includes('mac');
};
